// root saga container
// eslint-disable-next-line no-empty-function
function* rootSaga() {}

export default rootSaga;
